<template>
  <v-layout row wrap>
    <v-flex xs12>
      <v-card>
        <v-toolbar :color="dialog.color" card dark>
          <v-toolbar-title class="body-2">{{ dialog.title }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn @click="$emit('close')" icon>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-divider dark></v-divider>
          <v-card-text v-html="dialog.message"></v-card-text>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>
<script>
export default {
  props: {
    options: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dialog: {
        color: 'success',
        title: 'Mensaje del Sistema',
        message: '',
      },
    }
  },
  created() {
    this.dialog = { ...this.dialog, ...this.options }
  },
}
</script>
